
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"schoolSignup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teacherUsername"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teacherEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teacherPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teacherSpecialism"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teacherName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teacherFirstSurname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentUsername"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentSpecialism"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentFirstSurname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schoolSignup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teacherUsername"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teacherUsername"}}},{"kind":"Argument","name":{"kind":"Name","value":"teacherEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teacherEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"teacherPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teacherPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"teacherSpecialism"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teacherSpecialism"}}},{"kind":"Argument","name":{"kind":"Name","value":"teacherName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teacherName"}}},{"kind":"Argument","name":{"kind":"Name","value":"teacherFirstSurname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teacherFirstSurname"}}},{"kind":"Argument","name":{"kind":"Name","value":"studentUsername"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentUsername"}}},{"kind":"Argument","name":{"kind":"Name","value":"studentEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"studentPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"studentSpecialism"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentSpecialism"}}},{"kind":"Argument","name":{"kind":"Name","value":"studentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"studentFirstSurname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentFirstSurname"}}}],"directives":[]}]}}],"loc":{"start":0,"end":836}};
    doc.loc.source = {"body":"mutation schoolSignup(\n  $teacherUsername: String!\n  $teacherEmail: String!\n  $teacherPassword: String!\n  $teacherSpecialism: String!\n  $teacherName: String!\n  $teacherFirstSurname: String!\n  $studentUsername: String!\n  $studentEmail: String!\n  $studentPassword: String!\n  $studentSpecialism: String!\n  $studentName: String!\n  $studentFirstSurname: String!\n) {\n  schoolSignup(\n    teacherUsername: $teacherUsername\n    teacherEmail: $teacherEmail\n    teacherPassword: $teacherPassword\n    teacherSpecialism: $teacherSpecialism\n    teacherName: $teacherName\n    teacherFirstSurname: $teacherFirstSurname\n\n    studentUsername: $studentUsername\n    studentEmail: $studentEmail\n    studentPassword: $studentPassword\n    studentSpecialism: $studentSpecialism\n    studentName: $studentName\n    studentFirstSurname: $studentFirstSurname\n  )\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["schoolSignup"] = oneQuery(doc, "schoolSignup");
        
